"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetType = SetType;
function SetType(prototype, instance) {
    return instance && prototype.prototype
        ? Object.setPrototypeOf(instance, prototype.prototype)
        : instance;
}
//# sourceMappingURL=tag.js.map